<template>
  <div class="onboarding-welcome">
    <h1
      class="onboarding-welcome__welcome-message"
    >
      {{ $t('components.Onboarding.label.title.welcomeMessage') }}, {{ user.name }}
    </h1>
    <p
      class="onboarding-welcome__info-message"
    >
      {{ $t('components.Onboarding.label.title.infoMessage') }}
    </p>
    <DsButton
      color="primary"
      class="mt-5"
      @click="toggleIsStartingForm"
    >
      {{ $t('components.Onboarding.label.button.startFormButton') }}
    </DsButton>
  </div>
</template>

<script>
import { DsButton } from '@ds/components';

import { trackEventWithUserProperties } from '@/utils/mixpanel';
import onboardingModel from '@/mixins/onboarding-model';

export default {
  name: 'OnboardingWelcome',
  components: {
    DsButton,
  },
  mixins: [
    onboardingModel,
  ],
  methods: {
    toggleIsStartingForm() {
      trackEventWithUserProperties('ST OnboardingWizard Start View', { editorType: this.getEditorType() });

      this.$emit('toggle-starting');
    },
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-welcome {
    margin-top: 96px;
    margin-left: 85px;

    &__welcome-message {
      color: var(--ds-color-text-1);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xl);
      line-height: var(--ds-font-line-height-normal);
    }

    &__info-message {
      color: var(---ds-color-text-2);
      font-weight: var(--ds-font-weight-regular);
      font-size: var(--ds-font-size-baseline);
      line-height: var(--ds-font-line-height-normal);
      margin-bottom: 48px;
    }
  }
</style>
